import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { oddsDropBlock, RStatus, SCRRStatus, SCRStatus } from '@src/utils/kolBetpickUtils';

interface WinPLADataInter {
    no: string;
    status: string;
    name_ch: string;
    name_en: string;
    winOddsValue: string;
    winHotFavourite: boolean;
    winOddsDropValue: number;
    PLAOddsValue: string;
    PLAHotFavourite: boolean;
    PLAOddsDropValue: number;
}

interface Props {
    winPLAData: WinPLADataInter[];
    displayOdds: boolean;
    refundData: { WIN: boolean; PLA: boolean; QIN: boolean; QPL: boolean };
}

/** 用于betType为WIn-Place的样式 */
const WinPlace = (props: Props) => {
    // console.log('WIN-Place-------', props);
    const { i18n, t } = useTranslation('kol');
    const lang = i18n.language.toLowerCase() === 'en-us';
    const { winPLAData, displayOdds, refundData } = props;

    return (
        <div className='w-full'>
            <table className='w-full border-collapse text-[14px]'>
                <thead>
                    <tr
                        style={{ borderBottom: `1px solid #E0E0E0`, transform: 'translateY(-2px)' }}
                    >
                        <th className='text-left text-[11px] font-normal'>{t('horse')}</th>
                        {displayOdds && (
                            <>
                                <th className='text-center text-[11px] font-normal w-[36px]'>
                                    {t('Win')}
                                </th>
                                <th className='text-center text-[11px] font-normal w-[36px]'>
                                    {t('Pla')}
                                </th>
                            </>
                        )}
                    </tr>
                    <tr className='h-[1px]' />
                </thead>

                <tbody>
                    <tr className='h-1' />
                    {winPLAData.map((i, index) => {
                        const isSCR =
                            SCRStatus.includes(i.status) ||
                            i.PLAOddsValue === 'SCR' ||
                            i.winOddsValue === 'SCR';
                        const isR = RStatus.includes(i.status);
                        const isSCRR = SCRRStatus.includes(i.status);
                        const WINNoBG =
                            i.winOddsValue === 'SCR' || i.winOddsValue === '---' || refundData.WIN;
                        const PLANoBG =
                            i.PLAOddsValue === 'SCR' || i.PLAOddsValue === '---' || refundData.PLA;

                        return (
                            <tr
                                key={index}
                                className='text-[13px] font-bold text-black pt-[5px] h-[20px]'
                            >
                                <td>
                                    {`${i.no}. ${isR || isSCRR ? t('betpick.r') : ''}${
                                        lang ? i.name_en : i.name_ch
                                    }`}
                                    {(isSCR || isSCRR) && ` (${t('betpick.scratched')})`}
                                </td>
                                {displayOdds && (
                                    <>
                                        <td className={cn('text-center text-[#333]')}>
                                            <div
                                                className={`${
                                                    !WINNoBG &&
                                                    oddsDropBlock(
                                                        i.winHotFavourite,
                                                        i.winOddsDropValue
                                                    )
                                                }`}
                                            >
                                                {refundData.WIN
                                                    ? '---'
                                                    : isSCR || isSCRR
                                                    ? `${t('betpick.scratched')}`
                                                    : i.winOddsValue}
                                            </div>
                                        </td>
                                        <td className={cn('text-center text-[#333]')}>
                                            <div
                                                className={`${
                                                    !PLANoBG &&
                                                    oddsDropBlock(
                                                        i.PLAHotFavourite,
                                                        i.PLAOddsDropValue
                                                    )
                                                }`}
                                            >
                                                {refundData.PLA
                                                    ? '---'
                                                    : isSCR || isSCRR
                                                    ? `${t('betpick.scratched')}`
                                                    : i.PLAOddsValue}
                                            </div>
                                        </td>
                                    </>
                                )}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default memo(WinPlace);
